import i18n from '../i18n';

const nepaliDigits = ['०', '१', '२', '३', '४', '५', '६', '७', '८', '९'];

export function toLocalizedNumber(num) {
  if (num === null || num === undefined) return '';
  const str = String(num);
  if (i18n.language === 'np') {
    return str.replace(/[0-9]/g, (d) => nepaliDigits[parseInt(d)]);
  }
  return str;
}

export function toLocalizedPrice(amount) {
  if (amount === null || amount === undefined) return '';
  const formatted = Number(amount).toLocaleString('en-IN');
  if (i18n.language === 'np') {
    return formatted.replace(/[0-9]/g, (d) => nepaliDigits[parseInt(d)]);
  }
  return formatted;
}

export function toLocalizedStatus(status, t) {
  if (!status) return '';
  const statusMap = {
    'pending': t('common.status.pending'),
    'confirmed': t('common.status.confirmed'),
    'processing': t('common.status.processing'),
    'shipped': t('common.status.shipped'),
    'outForDelivery': t('common.status.outForDelivery'),
    'out for delivery': t('common.status.outForDelivery'),
    'delivered': t('common.status.delivered'),
    'received': t('common.status.received'),
    'cancelled': t('common.status.cancelled'),
    'completed': t('common.status.completed'),
    'failed': t('common.status.failed'),
    'refunded': t('common.status.refunded'),
    'paid': t('common.status.paid'),
    'unpaid': t('common.status.unpaid'),
    'active': t('common.status.active'),
    'inactive': t('common.status.inactive'),
    'approved': t('common.status.approved'),
    'rejected': t('common.status.rejected'),
    'underReview': t('common.status.underReview'),
    'under review': t('common.status.underReview'),
    'under_review': t('common.status.underReview'),
    'resolved': t('common.status.resolved'),
  };
  const key = status.toLowerCase().trim();
  return statusMap[key] || status.charAt(0).toUpperCase() + status.slice(1);
}
